{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "चिटकवा",
    "pasteAsPlaintext": "साधा मजकूर च्या रुपात पेस्ट करा",
    "pasteCharts": "चार्ट चिकटवा",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "समस्त निवडा",
    "multiSelect": "निवडित तत्व जोडा",
    "moveCanvas": "पटल हलवा",
    "cut": "कापा",
    "copy": "प्रतिलिपी",
    "copyAsPng": "PNG रूपे फळी वर कॉपी करा",
    "copyAsSvg": "SVG रूपे फळी वर कॉपी करा",
    "copyText": "लिखित रूपे फळी वर कॉपी करा",
    "copySource": "स्त्रोत फळी वर कॉपी करा",
    "convertToCode": "सांकेतिक लिपित रूपांतरित करा",
    "bringForward": "पुढे पुढे आणा",
    "sendToBack": "सर्वात मागे करा",
    "bringToFront": "सर्वात पुढे आणा",
    "sendBackward": "मागे मागे करा",
    "delete": "हटवा",
    "copyStyles": "शैली कॉपी करा",
    "pasteStyles": "कॉपी केलेली शैली वापरा",
    "stroke": "रेघे चा रंग",
    "changeStroke": "रेषेचा रंग बदला",
    "background": "पार्श्वभूमी",
    "changeBackground": "पार्श्वभूमीचा रंग बदला",
    "fill": "भरा",
    "strokeWidth": "रेघ रुंदी",
    "strokeStyle": "रेघ शैली",
    "strokeStyle_solid": "भरीव",
    "strokeStyle_dashed": "तुटित तुटित",
    "strokeStyle_dotted": "ठिपके ठिपके",
    "sloppiness": "गबाळेपणा",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "अपारदर्शक्ता",
    "textAlign": "मजकूर संरेखन",
    "edges": "किनारी",
    "sharp": "टोचरं",
    "round": "गोलाकार",
    "arrowheads": "बाण टोक",
    "arrowhead_none": "कुठलाहि नाही",
    "arrowhead_arrow": "बाण",
    "arrowhead_bar": "दांडुक",
    "arrowhead_circle": "वृत्त",
    "arrowhead_circle_outline": "वृत्त (बाह्यरेखा)",
    "arrowhead_triangle": "त्रिकोण",
    "arrowhead_triangle_outline": "त्रिभुज (बाह्यरेखा)",
    "arrowhead_diamond": "चौकट",
    "arrowhead_diamond_outline": "चौकट (बाह्यरेखा)",
    "arrowhead_crowfoot_many": "चिमणि पाय (अनेक)",
    "arrowhead_crowfoot_one": "चिमणि पाय (एक)",
    "arrowhead_crowfoot_one_or_many": "चिमणि पाय (एक अथवा अनेक)",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "आणिक विकल्प",
    "cardinality": "",
    "arrowtypes": "बाणाचे प्रकार",
    "arrowtype_sharp": "तीक्ष्ण तीर",
    "arrowtype_round": "वक्राकार तीर",
    "arrowtype_elbowed": "समकोणिय तीर",
    "fontSize": "अक्षर आकार",
    "fontFamily": "अक्षर समूह",
    "addWatermark": "\"एक्सकेलीड्रॉ ने बनवलेलं\" जोडा",
    "handDrawn": "हातानी बनवलेलं",
    "normal": "सामान्य",
    "code": "सांकेतिक लिपि",
    "small": "छोटे",
    "medium": "मध्यम",
    "large": "मोठं",
    "veryLarge": "फार मोठं",
    "solid": "भरीव",
    "hachure": "हैशूर रेखांकन",
    "zigzag": "वाकडी तिकड़ी",
    "crossHatch": "आडव्या रेघा",
    "thin": "पातळ",
    "bold": "जाड",
    "left": "डावं",
    "center": "मधे",
    "right": "उजवं",
    "extraBold": "जास्त जाड",
    "architect": "वास्तुविद्याविशारद",
    "artist": "कलाकार",
    "cartoonist": "व्यंग्य चित्रकार",
    "fileTitle": "फाईलचे नाव",
    "colorPicker": "रंग निवडक",
    "canvasColors": "कॅनवास वर वापरलेले",
    "canvasBackground": "पटल पार्श्वभूमि",
    "drawingCanvas": "चित्र पटल",
    "clearCanvas": "पटल स्वच्छ करा",
    "layers": "स्तर",
    "actions": "क्रिया",
    "language": "भाषा",
    "liveCollaboration": "ज्वलंत सहयोग...",
    "duplicateSelection": "प्रतिलिपि",
    "untitled": "अशीर्षकांकित",
    "name": "नाव",
    "yourName": "तुमचे नाव",
    "madeWithExcalidraw": "एक्सकेलीड्रॉ ने बनवलेलं",
    "group": "समूह निवड",
    "ungroup": "समूह निवड ला रद्द करा",
    "collaborators": "Sahayog",
    "you": "",
    "toggleGrid": "जाळी ऑन ऑफ़ करा",
    "loadingScene": "दृश्य लोड होत आहे…",
    "loadScene": "फ़ाइल पासून दृश्य लोड करा",
    "align": "संरेखित करा",
    "alignTop": "वर संरेखित करा",
    "alignBottom": "खाली संरेखित करा",
    "alignLeft": "डावा बाजूला संरेखित करा",
    "alignRight": "उजव्या बाजूला संरेखित करा",
    "centerVertically": "मधल्या मधे उभं संरेखित करा",
    "centerHorizontally": "मधल्या मधे आडवं संरेखित करा",
    "distributeHorizontally": "आडवं वितरित करा",
    "distributeVertically": "उभं वितरित करा",
    "flipHorizontal": "आडवं फ्लिप करा",
    "flipVertical": "उभं फ्लिप करा",
    "viewMode": "पहायची पद्धत",
    "share": "सामायिक करा",
    "showStroke": "रेघ रंग निवड यंत्र दाखवा",
    "showBackground": "पार्श्वभूमि: रंग निवड यंत्र दाखवा",
    "showFonts": "लिपि निवड़क दाखवा",
    "toggleTheme": "उजेड़ाची किव्हा अंधाराची प्रणाली बदला",
    "theme": "संरचना पद्धति",
    "decreaseFontSize": "अक्षर आकार छोटा करा",
    "increaseFontSize": "अक्षर आकार मोठा करा",
    "unbindText": "लेखन संबंध संपवा",
    "bindText": "शब्द समूह ला पात्रात घ्या",
    "createContainerFromText": "मजकूर कंटेनर मधे मोडून दाखवा",
    "link": {
      "edit": "दुवा संपादन",
      "editEmbed": "रुतलेल्या दुवा ह्याचे संपादन",
      "create": "दुवा जोडा",
      "label": "दुवा",
      "labelEmbed": "कड़ी आणि रूतवणे",
      "empty": "कुठलिही कड़ी दिली नाही",
      "hint": "आपला दुवा येथे टाइप करा अथवा येथे चिटकवा",
      "goToElement": "निर्धारित घटक या वर जावे"
    },
    "lineEditor": {
      "edit": "रेघ संपादन",
      "editArrow": "बाण संपादन"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "कुलूपात ठेवा",
      "unlock": "कुलूपातून बाहेर",
      "lockAll": "सर्व कुलूपात ठेवा",
      "unlockAll": "सर्व कुलूपातून बाहेर"
    },
    "sidebarLock": "साइडबार उघडं ठेवा",
    "selectAllElementsInFrame": "चौकटीतले सर्व तत्वांचे चयन करा",
    "removeAllElementsFromFrame": "चौकटीतून सर्व काढून टाका",
    "eyeDropper": "चित्रफलकातून रंग निवडा",
    "followUs": "आमचं अनुकरण करा",
    "discordChat": "डिस्कोर्ड संवाद",
    "zoomToFitViewport": "पूर्ण दृश्यरूप आकार",
    "zoomToFitSelection": "निवडी प्रयंत दृश्यरूप आकार करा",
    "zoomToFit": "सर्व तत्व दिसतील असे दृश्यरूप आकार करा",
    "installPWA": "एक्षकाली ड्रॉ स्थानीय स्वरूपात इंस्टॉल करावे (PWA)",
    "autoResize": "स्वयं आकार पुनः निर्धारण",
    "imageCropping": "प्रतिमा कापणे",
    "unCroppedDimension": "कापण्या पूर्विचे परिमाण",
    "copyElementLink": "वस्तू ह्याचा दुवा कॉपी करावे",
    "linkToElement": "वस्तू ह्याचा दुवा",
    "wrapSelectionInFrame": "चौकटित निवडलेले गुंडाळा",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "वस्तू ह्याचा दुवा",
    "desc": "चित्र-पटल वरचा कोणताही आकारावर क्लिक करावे अथवा दुवा ह्याला चिटकावे.",
    "notFound": "चित्र-पटल वर दुवा वाली वस्तू सापडली नाही."
  },
  "search": {
    "title": "पटल वर पहा",
    "noMatch": "मिळते जुळते काहिही सापडले नाही...",
    "singleResult": "निकाल",
    "multipleResults": "निकाल",
    "placeholder": "पटल वर पाठ्य शोधा...",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "पटल पुसा",
    "exportJSON": "फ़ाइलमधे बाहेर ठेवा",
    "exportImage": "प्रतिमा निर्यात करा...",
    "export": "येथे सुरक्षित करा...",
    "copyToClipboard": "फळी वर कॉपी करा",
    "copyLink": "कड़ी ची कॉपी करावी",
    "save": "वर्तमान फ़ाइल मधे जतन करा",
    "saveAs": "ह्या नावाने जतन करा",
    "load": "उघडा",
    "getShareableLink": "सामायिके साठी दुवा प्राप्त करा",
    "close": "बंद करा",
    "selectLanguage": "भाषा निवड करा",
    "scrollBackToContent": "पहलेचा मजकुर वर मागे स्क्रॉल करा",
    "zoomIn": "मोठं करून पहा",
    "zoomOut": "छोटं करून पहा",
    "resetZoom": "छोटं मोठं करणं बंद करा",
    "menu": "यादि",
    "done": "झालं",
    "edit": "संपादित करा",
    "undo": "पूर्ववत करा",
    "redo": "पुन्हा करा(&R)",
    "createNewRoom": "एक नवी खोली बनवा",
    "fullScreen": "पूर्ण दृश्यपटल",
    "darkMode": "अंधार स्थिथि",
    "lightMode": "उजेड स्थिति",
    "systemMode": "तांत्रिक पद्धत",
    "zenMode": "ध्यानग्र स्थिति",
    "objectsSnapMode": "वस्तूंपासून पकड़ा",
    "exitZenMode": "ध्यानग्र स्थितितून बाहेर",
    "cancel": "रद्द",
    "clear": "स्वछ",
    "remove": "हटवा",
    "embed": "रुतवणे पलटे करा",
    "submit": "जमा करा",
    "confirm": "पुष्टि करा",
    "embeddableInteractionButton": "संवादा साठी क्लिक करा"
  },
  "alerts": {
    "clearReset": "पटल स्वच्छ होणार, तुम्हाला खात्री आहे का?",
    "couldNotCreateShareableLink": "सामायी करण करण्या योग्य दुवा नाही बनवता आला.",
    "couldNotCreateShareableLinkTooBig": "सामायी करण करण्या योग्य दुवा नाही बनवता आला: दृश्य फार मोठं आहे",
    "couldNotLoadInvalidFile": "अवैध फ़ाइल लोड करता आली नाही",
    "importBackendFailed": "बैकएंड हून मागवणे विफल झाले.",
    "cannotExportEmptyCanvas": "रिकामा पटल जतन करता येत नाही.",
    "couldNotCopyToClipboard": "पटल वर कॉपी नाही झाली.",
    "decryptFailed": "डीक्रिप्ट करता आले नाही.",
    "uploadedSecurly": "अपलोड या टोकापासून त्या टोकापर्यंत कूटबद्धित करून सुरक्षित केले गेले आहे, हयाचा अर्थ असा की एक्सकेलीड्रॉ सर्व्हर आणि तृतीय पक्ष मजकूर वाचू शकत नाहीत.",
    "loadSceneOverridePrompt": "बाह्य रेखाचित्र लोड केल्याने तुमची तुमचा विद्यमान मजकूर बदलेल. हे काम तुम्हाला चालू ठेवायचे आहे का?",
    "collabStopOverridePrompt": "सत्र थांबवल्याने तुमचे पूर्वीचे, स्थानिकरित्या संग्रहित रेखाचित्र अधिलिखित होईल. तुला खात्री आहे?\n\n(तुम्हाला तुमचे स्थानिक रेखाचित्र ठेवायचे असल्यास, त्याऐवजी फक्त ब्राउझर टॅब बंद करा.)",
    "imageDoesNotContainScene": "या प्रतिमेमध्ये कोणताही दृश्य डेटा असल्याचे दिसत नाही. बाहेर जतन करताना तुम्ही दृश्य रुतवले होते का?",
    "cannotRestoreFromImage": "प्रतिमा फ़ाइल पासून दृश्य पुनः रचित नाही झाला",
    "invalidSceneUrl": "दिलेल्या यू-आर-एल पासून दृश्य आणू शकलो नाही. तो एकतर बरोबार नाही आहे किंवा त्यात वैध एक्सकेलीड्रॉ जेसन डेटा नाही.",
    "invalidEncryptionKey": "कूटबद्धन कुंजी 22 अक्षरांची असणे आवश्यक आहे. थेट सहयोग अक्षम केले आहे.",
    "collabOfflineWarning": "इंटरनेट कनेक्शन उपलब्ध नाही.\nतुमचे बदल जतन केले जाणार नाहीत!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "असमर्थित फाइल प्रकार.",
    "imageInsertError": "प्रतिमा आत घालता येत नाही. नंतर पुन्हा प्रयत्न करा...",
    "fileTooBig": "फाइल फार मोठी आहे. आकाराची कमाल परवानगी {{maxSize}} आहे.",
    "svgImageInsertError": "एस-वी-जी प्रतिमा आत घालवू शकलो नाही. एस-वी-जी-मार्क-अप यंत्र अयोग्य आहे.",
    "failedToFetchImage": "प्रतिमा आणणे नाही जमले.",
    "cannotResolveCollabServer": "कॉलेब-सर्वर हे पोहोचत नाही आहे. पान परत लोड करायचा प्रयत्न करावे.",
    "collabSaveFailed": "काही कारणा निमित्त आतल्या डेटाबेसमध्ये जतन करू शकत नाही। समस्या तशिस राहिल्यास, तुम्ही तुमचे काम गमावणार नाही याची खात्री करण्यासाठी तुम्ही तुमची फाइल स्थानिक जतन करावी.",
    "collabSaveFailed_sizeExceeded": "लगता है कि पृष्ठ तल काफ़ी बड़ा है, इस्कारण अंदरूनी डेटाबेस में सहेजा नहीं जा सका। किये काम को खोने न देने के लिये अपनी फ़ाइल को स्थानीय रूप से सहेजे।\n\nबॅकएंड डेटाबेसमध्ये जतन करू शकत नाही, कॅनव्हास खूप मोठा असल्याचे दिसते. तुम्ही तुमचे काम गमावणार नाही याची खात्री करण्यासाठी तुम्ही फाइल स्थानिक पातळीवर जतन करावी.",
    "imageToolNotSupported": "प्रतिमां अक्षम केली गेली आहेत.",
    "brave_measure_text_error": {
      "line1": "असं वाटते की तुम्हीं Brave ब्राउज़र वापरतात आहात आणि त्या बरोबार <bold>आक्रामक पद्धति चें बोटांचे ठसे </bold> हां सेटिंग्स चा विकल्प चयन केलेला आहे.",
      "line2": "हे तुमच्या चित्रांच्या <bold>पाठ तत्वांनां </bold> खंडित करू शकतात.",
      "line3": "तुम्हाला आमच्या कड़ून खूप आग्रह आहे की हे सेटिंग्स मधले चयन नका करु. <link>हे अनुक्रम </link> हे कसे करावे हे दाखवु शकते.",
      "line4": "ही सेटिंग अक्षम करूनही पृष्ठ योग्यरित्या प्रदर्शित होत नसल्यास, आमच्या GitHub वर <issueLink>समस्या</issueLink> सबमिट करा, किव्हा <discordLink>डिस्कॉर्ड</discordLink> वर आम्हाला लिहा"
    },
    "asyncPasteFailedOnRead": "चिटकवता नाही जमले ( सिस्टम क्लिप्बॉर्ड पासून वाचणे नाही जमले).",
    "asyncPasteFailedOnParse": "चिटकवता नाही जमले.",
    "copyToSystemClipboardFailed": "क्लिपबोर्ड वर प्रतिलिपि करणे नाही जमले."
  },
  "toolBar": {
    "selection": "निवड",
    "lasso": "",
    "image": "प्रतिमा आत घाला",
    "rectangle": "आयत",
    "diamond": "चौकोन आकाराचा",
    "ellipse": "अंडाकार",
    "arrow": "बाण",
    "line": "रेखा",
    "freedraw": "रेखांकित करा",
    "text": "टेक्स्ट",
    "lock": "निवडलेले यंत्र चित्रकरण झाल्या नंतर ही सक्रिय ठेवा",
    "penMode": "पेन चा मोड - स्पर्श टाळा",
    "link": "निवडलेल्या आकारासाठी दुवा जोडा/बदल करा",
    "eraser": "खोड रबर",
    "frame": "चौकट यंत्र",
    "embeddable": "वेब रुतवा",
    "laser": "लेसर टॉर्च",
    "autoshape": "",
    "bucketfill": "",
    "hand": "हात ( सरकवण्या चे उपकरण)",
    "extraTools": "आणिक यंत्रे",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "आयत",
    "diamond": "चौकट",
    "ellipse": "लंबवर्तुळाकार",
    "arrow": "बाण",
    "line": "रेषा",
    "freedraw": "मुक्त चित्रांकन",
    "text": "पाठ्य",
    "image": "प्रतिमा",
    "group": "गट",
    "frame": "चौकट",
    "embeddable": "वेब रुतवा",
    "selection": "निवड",
    "iframe": "आयफ़्रेम"
  },
  "headings": {
    "canvasActions": "पटल क्रिया",
    "selectedShapeActions": "निवडित आकार क्रिया",
    "shapes": "आकार"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "अनेक बिंदु साठी क्लिक करा, रेघे साठी ड्रैग करा",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "क्लिक आणि ड्रैग करा, झालं तेव्हा सोडा",
    "text": "टीप: तुम्हीं निवड यंत्रानी कोठेही दुहेरी क्लिक करून टेक्स्ट जोडू शकता",
    "embeddable": "वेबसाइट रुतोण्या साठी दाबून-खेचा (क्लिक-ड्रैग करा)",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "हे वैशिष्ट्य \"dom.events.asyncClipboard.clipboardItem\" फ्लॅग \"सत्य\" वर सेट करून शक्यतो सक्षम केले जाऊ शकते. Firefox मध्ये ब्राउझर फ्लॅग बदलण्यासाठी, \"about:config\" पृष्ठावर जा.",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "पूर्वावलोकन दाखवू शकत नाही",
    "canvasTooBig": "पटल खूप जास्त मोठा असू शकतो.",
    "canvasTooBigTip": "टीप: दूर चा तत्व थोडं जवळ आणण्याचा प्रयत्न करावा."
  },
  "errorSplash": {
    "headingMain": "त्रुटि आली. परत प्रयत्न करा <button>ह्या पानाला पुनः लोड करा.</button>",
    "clearCanvasMessage": "रीलोडिंग होत नसल्यास, परत प्रयत्न करा <button>पटल स्वच्छ करित आहे.</button>",
    "clearCanvasCaveat": " त्यामुळे केलेल्या कामाचे नुकसान होईल ",
    "trackedToSentry": "त्रुटि क्रमांक के साथ त्रुटि {{eventId}} आमच्या प्रणाली नी निरीक्षण केले होते.",
    "openIssueMessage": "त्रुटीत तुमची दृश्य माहिती समाविष्ट न करण्यासाठी आम्ही खूप सावध होतो. तुमचा सीन खाजगी नसल्यास, कृपया आम्हाला पुढ च्या कारवाई साठी सम्पर्क साधा <button>त्रुटि व्यवस्थापन.</button> कृपया गिटहब समस्येमध्ये कॉपी आणि पेस्ट करून खालिल माहिती समाविष्ट करा.",
    "sceneContent": "दृश्य विषय:"
  },
  "shareDialog": {
    "or": "किंव्हा"
  },
  "roomDialog": {
    "desc_intro": "तुमच्या चित्रात सहभागी व्हायला लोकांना आमंत्रित करा.",
    "desc_privacy": "चिंते चं कही कारण नाही, सत्र ह्या टोका ते त्या टोका पर्यंत कूटबद्ध आहे, वर पूर्ण प्रकारे खाजगी पण. आपण काय चित्रित करता आहे हे आमचे सर्व्हर देखील पाहू शकत नाही.",
    "button_startSession": "सत्र सुरु करा",
    "button_stopSession": "सत्र थाम्बवा",
    "desc_inProgressIntro": "थेट सहयोग सत्र चालू आहे.",
    "desc_shareLink": "तुम्ही ज्यांच्याशी सहयोग करू इच्छिता त्यांच्याशी ही दुवा सामायिक करा:",
    "desc_exitSession": "सत्र थांबवल्याने तुम्हीं खोली तून बाहेर याल, तरिही तुम्ही स्थानिक पातळीवर दृश्यासह काम करु शकाल. लक्षात ठेवा की याचा इतर लोकांवर परिणाम होणार नाही आणि ते त्यांच्या आवृत्तीवर सहयोग करित राहातील.",
    "shareTitle": "एक्सकेलीड्रॉ वर थेट सहयोग सत्रात सामील व्हा"
  },
  "errorDialog": {
    "title": "त्रुटि"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "डिस्क मधे जतन करा",
    "disk_details": "सीन डेटा बाहेर एक फ़ाइल मधे जतन करा, त्या फ़ाइल मधुम तो डेटा नंतर परत आणु शकता.",
    "disk_button": "फ़ाइल मधे जतन करा",
    "link_title": "सामायिके साठी दुवा",
    "link_details": "नुसतं वाचु देणारा दुवा चा स्वरूपे बाहेर ठेवा.",
    "link_button": "दुवा स्वरूपे बाहेर ठेवा",
    "excalidrawplus_description": "दृश्य तुमच्या एक्सकेलीड्रॉ कार्यक्षेत्र मधे जतन करा.",
    "excalidrawplus_button": "बाहेर ठेवा",
    "excalidrawplus_exportError": "एक्सकेलीड्रॉ मधे बाहेर ठेवता नाही येत..."
  },
  "helpDialog": {
    "blog": "आमचा ब्लॉग वाचा",
    "click": "क्लिक करा",
    "deepSelect": "खोल निवड",
    "deepBoxSelect": "चौकट मधे खोल निवड करा आणि बाहेर ओढणे वाचवा",
    "createFlowchart": "एका सामान्य अवयवा पासून प्रवाहचित्र बनवा",
    "navigateFlowchart": "प्रवाहचित्रा चं अनुकरण करा",
    "curvedArrow": "वक्र बाण",
    "curvedLine": "वक्र रेघ",
    "documentation": "कागदपत्रे",
    "doubleClick": "दुहेरी क्लिक",
    "drag": "ओढा",
    "editor": "संपादक",
    "editLineArrowPoints": "रेघ/तीर बिंदु सम्पादित करा",
    "editText": "पाठ्य सम्पादित करा/ लेबल जोडा",
    "github": "समस्या मिळाली? प्रस्तुत करा",
    "howto": "आमच्या मार्गदर्शकाचे अनुसरण करा",
    "or": "किंवा",
    "preventBinding": "बाण बंधन होणं टाळा",
    "tools": "अवजार",
    "shortcuts": "कीबोर्ड शॉर्टकट",
    "textFinish": "संपादन संपले (मजकूर संपादन)",
    "textNewLine": "नवी ओळ जोडा (मजकूर संपादक)",
    "title": "मदत",
    "view": "दृश्य",
    "zoomToFit": "सर्व तत्व दिसतील असे दृश्यरूप आकार करा",
    "zoomToSelection": "निवडी प्रयंत दृश्यरूप आकार करा",
    "toggleElementLock": "कुलूपातून आत/बाहेर निवड",
    "movePageUpDown": "पान वर/खाली करा",
    "movePageLeftRight": "पान डावी/उजवी कडे करा",
    "cropStart": "प्रतिमा ह्याची कापणी करा",
    "cropFinish": "प्रतिमा ह्याची कापणी संपूर्ण करा"
  },
  "clearCanvasDialog": {
    "title": "पटल स्वच्छ करा"
  },
  "imageExportDialog": {
    "header": "प्रतिमा निर्यात करा",
    "label": {
      "withBackground": "पार्श्वभूमि",
      "onlySelected": "फक्त चयन केलेले",
      "darkMode": "अंधारमय स्थिति",
      "embedScene": "दृश्य रुतवा",
      "scale": "क़िती पट",
      "padding": "ग़ादी"
    },
    "tooltip": {
      "embedScene": "दृश्य डेटा निर्यात केलेल्या पी-एन-जी किव्हा एस-वी-जी फ़ाईल मधे सुरक्षीत केला जाईल, त्याने दृश्य पुनः परत आणता येईल. निर्यात केलेली फ़ाईल चा आकार त्याने वाढेल."
    },
    "title": {
      "exportToPng": "पी-एन-जी स्वरूपात बाहेर ठेवा",
      "exportToSvg": "एस-वी-जी स्वरूपात बाहेर ठेवा",
      "copyPngToClipboard": "पी-एन-जी रूपे फळी वर कॉपी करा"
    },
    "button": {
      "exportToPng": "पीएनजी",
      "exportToSvg": "एसविज़ी",
      "copyPngToClipboard": "फळी वर कॉपी करा"
    }
  },
  "encrypted": {
    "tooltip": "तुमचे चित्रे या टोकापासून त्या टोकापर्यंत कूटबद्धतित आहेत, त्या कारणांनी ऐक्सकैलिड्रॉ सर्वर्स ह्यानां ते पहाणं कधीच जमणार नाही.",
    "link": "ब्लॉग पोस्ट ऐक्सकैलिड्रॉ मधे या टोकापासून त्या टोकापर्यंत कूटबद्धतित आहेत"
  },
  "stats": {
    "angle": "कोण",
    "shapes": "आकार",
    "height": "उंची",
    "scene": "दृश्य",
    "selected": "निवडलेले",
    "storage": "साठवण",
    "fullTitle": "पटल आणि आकार गुण",
    "title": "गुण",
    "generalStats": "सर्वसामान्य",
    "elementProperties": "अकाराचे गुण",
    "total": "योग",
    "version": "आवृत्ती",
    "versionCopy": "कॉपी करायला क्लिक करा",
    "versionNotAvailable": "आवृति उपलब्ध नाही",
    "width": "रुंदी"
  },
  "toast": {
    "copyStyles": "कॉपी केलेली शैली.",
    "copyToClipboard": "फळी वर कॉपी झाली.",
    "copyToClipboardAsPng": "{{exportSelection}} फळी वर पी-एन-जी स्वरूपात कॉपी झाली\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} फळी वर एस-वी-जी स्वरूपात कॉपी झाली\n({{exportColorScheme}})",
    "fileSaved": "फ़ाइल जतन झाली.",
    "fileSavedToFilename": "{filename} मधे जतन झाली",
    "canvas": "पटल",
    "selection": "निवड",
    "pasteAsSingleElement": "एक घटक म्हणून चिपकावण्या साठी {{shortcut}} वापरा,\nकिंवा विद्यमान मजकूर संपादकात चिपकवा",
    "unableToEmbed": "युआरेल रूतवणे प्रतिबंधित आहेत. आपली युआरेल श्वेतसूचित आणण्या साठी कृपया एक मुद्दा ग़िटहब वर उठवा",
    "unrecognizedLinkFormat": "जी युआरेल तुम्हीं रतवली आहे, ती आपेक्षित प्रकारे नाही आहे. कृपया स्त्रोत साइट नी 'रूतवण्या साठी दिलेलि लिपि' चिपकावण्याचा प्रयास करा",
    "elementLinkCopied": "दुवा क्लिप बोर्ड वर कॉपी झाली"
  },
  "colors": {
    "transparent": "पारदर्शक",
    "black": "काळा",
    "white": "पांढरा",
    "red": "लाल",
    "pink": "गुलाबी",
    "grape": "अंगूरी",
    "violet": "जांभळा",
    "gray": "राखाडी",
    "blue": "निळा",
    "cyan": "आकाशी",
    "teal": "हिरवट निळा",
    "green": "हिरवा",
    "yellow": "पिवळा",
    "orange": "केशरी",
    "bronze": "कांस्य"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "त्याऐवजी तुम्हाला Excalidraw+ वर जायचे आहे का?",
      "menuHint": "निर्यात, आवड़ी-निवडी, भाषा, ..."
    },
    "defaults": {
      "menuHint": "निर्यात, आवड़ी निवडी आणि आणकिही...",
      "center_heading": "आकृत्या. काढणे. सोपे.",
      "toolbarHint": "एक साधन निवडा आणि चित्रीकरण सुरु करा!",
      "helpHint": "शॉर्टकट आणि सहाय्य"
    }
  },
  "colorPicker": {
    "color": "रंग",
    "mostUsedCustomColors": "सर्वात जास्त वापरणीस रंग",
    "colors": "रंग",
    "shades": "रंगछटा",
    "hexCode": "हेक्स कोड",
    "noShades": "ह्या रंगाच्या छटा उपलब्ध नाहित",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "छवि स्वरूपे निर्यात करा",
        "button": "छवि स्वरूपे निर्यात करा",
        "description": "सीन डेटा बाहेर एक फ़ाइल मधे जतन करा, त्या फ़ाइल मधुन तो डेटा नंतर परत आणु शकता."
      },
      "saveToDisk": {
        "title": "डिस्क मधे जतन करा",
        "button": "डिस्क मधे जतन करा",
        "description": "सीन डेटा बाहेर एक फ़ाइल मधे जतन करा, त्या फ़ाइल मधुन तो डेटा नंतर परत आणु शकता."
      },
      "excalidrawPlus": {
        "title": "एक्षकालीड्रॉ +",
        "button": "एक्षकाली ड्रॉ+ मधे निर्यात करा",
        "description": "दृष्य तुमच्या एक्षकालीड्रॉ+ चा कार्यस्थल मधे जतन करा."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "फ़ाइल मधुन लोड करा",
        "button": "फ़ाइल मधुन लोड करा",
        "description": "फ़ाइल मधुन लोड केल्या वर ते <bold>तुमचा सध्याचा कामा ठिकाणि एईल </bold><br></br> तुम्हीं तुमचं चित्र एकाधं खाली दिलेलं विकल्प निवडुन पहले सुरक्षीत करु शकता."
      },
      "shareableLink": {
        "title": "लिंक पासून लोड करा",
        "button": "माझ सध्याचे कार्य बदला",
        "description": "बाहरी चित्र लोड केल्या वर ते <bold>तुमचा सध्याचा कामा ठिकाणि एईल </bold><br></br> तुम्हीं तुमचं चित्र एकाधं खाली दिलेलं विकल्प निवडुन पहले सुरक्षीत करु शकता."
      }
    }
  },
  "quickSearch": {
    "placeholder": "जलद शोध"
  },
  "fontList": {
    "badge": {
      "old": "ज़ुनं"
    },
    "sceneFonts": "ह्या दृश्या मधे",
    "availableFonts": "उपलब्ध लीपीं",
    "empty": "लिपि सपडली नाहीं"
  },
  "userList": {
    "empty": "वापरकर्ते सापडले नाहीत",
    "hint": {
      "text": "प्रयोक्ताचं अनुकरण करण्या साठी त्या वर क्लिक करा",
      "followStatus": "तुम्हीं सध्या ह्या उपयोक्ता चं अनुकरण करत आहेत",
      "inCall": "व्यक्ति सध्या संभाषण मधे व्यस्त आहे",
      "micMuted": "व्यक्ति चा माइक्रोफ़ोन सध्या मूक केलेला आहे",
      "isSpeaking": "व्यक्ति सध्या बोलत आहे"
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
